import { render, staticRenderFns } from "./ModalCreateBusinessAccount.vue?vue&type=template&id=b51dc3b2&scoped=true"
import script from "./ModalCreateBusinessAccount.vue?vue&type=script&lang=js"
export * from "./ModalCreateBusinessAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateBusinessAccount.vue?vue&type=style&index=0&id=b51dc3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51dc3b2",
  null
  
)

export default component.exports